import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Cloud8 from "../../../Img/clouds8.png";
import AOS from "aos";

export default function DedicatedHiringProfileContent() {
  useEffect(() => {
    AOS.init({
      once: true,
      offset: 120,
    });
  }, []);
  return (
    <>
      <section className="content-block">
        <Container>
          <Row>
            <div className="col-lg-12">
              <div
                className="sec-title"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="500"
              >
                <img className="cloud" src={Cloud8} alt="cloud" />
                <h2>
                  <span>What is dedicated hiring?</span>
                </h2>
              </div>
            </div>
          </Row>
          <Row>
            <div className="col-lg-12">
              <div
                className="heading-text"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="500"
              >
                Dedicated hiring is a customised recruitment solution that
                allows businesses to tap into a pool of specialised talent. By
                partnering with us, you gain access to a dedicated team of
                professionals who understand your industry, culture, and
                specific needs. This service streamlines the hiring process,
                ensuring you find the right candidates efficiently and
                effectively.
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
}
